import { render, staticRenderFns } from "./MasterCostFactor.vue?vue&type=template&id=056573a2&scoped=true&"
import script from "./MasterCostFactor.vue?vue&type=script&lang=js&"
export * from "./MasterCostFactor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "056573a2",
  null
  
)

export default component.exports